import { makeZodValidate } from '@occc-app/design-system';
import { schema } from './transactions-filter-form.schema';

export const validateFilterForm = makeZodValidate(schema);
